import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const HoroscopoChino = () => {
  const navigate = useNavigate();
  const [selectedSign, setSelectedSign] = useState("rata");

  const chineseZodiacSigns = [
    { id: "rata", name: "Rata", emoji: "🐀", years: "1924, 1936, 1948, 1960, 1972, 1984, 1996, 2008, 2020" },
    { id: "buey", name: "Buey", emoji: "🐂", years: "1925, 1937, 1949, 1961, 1973, 1985, 1997, 2009, 2021" },
    { id: "tigre", name: "Tigre", emoji: "🐅", years: "1926, 1938, 1950, 1962, 1974, 1986, 1998, 2010, 2022" },
    { id: "conejo", name: "Conejo", emoji: "🐇", years: "1927, 1939, 1951, 1963, 1975, 1987, 1999, 2011, 2023" },
    { id: "dragon", name: "Dragón", emoji: "🐉", years: "1928, 1940, 1952, 1964, 1976, 1988, 2000, 2012, 2024" },
    { id: "serpiente", name: "Serpiente", emoji: "🐍", years: "1929, 1941, 1953, 1965, 1977, 1989, 2001, 2013, 2025" },
    { id: "caballo", name: "Caballo", emoji: "🐎", years: "1930, 1942, 1954, 1966, 1978, 1990, 2002, 2014, 2026" },
    { id: "cabra", name: "Cabra", emoji: "🐐", years: "1931, 1943, 1955, 1967, 1979, 1991, 2003, 2015, 2027" },
    { id: "mono", name: "Mono", emoji: "🐵", years: "1932, 1944, 1956, 1968, 1980, 1992, 2004, 2016, 2028" },
    { id: "gallo", name: "Gallo", emoji: "🐓", years: "1933, 1945, 1957, 1969, 1981, 1993, 2005, 2017, 2029" },
    { id: "perro", name: "Perro", emoji: "🐕", years: "1934, 1946, 1958, 1970, 1982, 1994, 2006, 2018, 2030" },
    { id: "cerdo", name: "Cerdo", emoji: "🐖", years: "1935, 1947, 1959, 1971, 1983, 1995, 2007, 2019, 2031" },
  ];

  const selectedZodiac = chineseZodiacSigns.find(sign => sign.id === selectedSign);

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold mb-4 text-primary">Horóscopo Chino</h1>
          <p className="text-xl text-muted-foreground">
            Descubre las predicciones según el zodiaco chino
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
          {chineseZodiacSigns.map((sign) => (
            <Card 
              key={sign.id}
              className={`cursor-pointer transition-all hover:scale-105 ${
                selectedSign === sign.id ? 'ring-2 ring-primary' : ''
              }`}
              onClick={() => {
                setSelectedSign(sign.id);
                navigate(`/horoscopo-${sign.id}`);
              }}
            >
              <CardContent className="p-6 text-center">
                <div className="text-5xl mb-3">{sign.emoji}</div>
                <h3 className="font-semibold text-lg">{sign.name}</h3>
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="text-7xl mb-4">{selectedZodiac?.emoji}</div>
              <h2 className="text-3xl font-bold mb-2">{selectedZodiac?.name}</h2>
              <p className="text-muted-foreground">Años: {selectedZodiac?.years}</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Las energías cósmicas favorecen las conexiones profundas hoy. Si estás en pareja, es un momento perfecto para fortalecer la comunicación. Los solteros pueden tener encuentros significativos en lugares inesperados.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu creatividad está en su punto máximo. Es un excelente día para presentar nuevas ideas o proyectos. La colaboración con colegas puede traer resultados sorprendentes.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Escucha a tu cuerpo y tómate tiempo para el descanso. Las actividades al aire libre o la meditación pueden ayudarte a mantener el equilibrio físico y mental.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será un día de romanticismo y ternura. Las parejas disfrutarán de momentos íntimos y especiales. Los solteros podrían recibir una sorpresa agradable de alguien especial.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Se avecinan oportunidades interesantes. Mantén los ojos abiertos ante nuevas posibilidades de crecimiento profesional o proyectos innovadores.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía estará en niveles óptimos. Es un buen momento para iniciar una nueva rutina de ejercicios o hábitos saludables que deseas incorporar.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana promete ser emocionante en el ámbito amoroso. Las relaciones establecidas alcanzarán nuevos niveles de comprensión. Los solteros tendrán múltiples oportunidades para conocer personas interesantes.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana de logros y reconocimiento profesional. Tus esfuerzos serán valorados y podrías recibir noticias positivas sobre proyectos en los que has trabajado.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Mantén un equilibrio entre trabajo y descanso durante esta semana. Tu bienestar general será excelente si priorizas el autocuidado y mantienes una actitud positiva.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoChino;
